import { z } from 'zod';

// New schema matching server-side ErrorResponseSchema from base-express
export const ErrorResponseSchema = z.object({
    error: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    hint: z.string().nullable(),
    details: z
        .array(
            z.object({
                path: z.array(z.union([z.string(), z.number()])),
                error: z.string(),
                description: z.string(),
            })
        )
        .optional(),
    retryable: z.boolean(),
});

// Keep existing schema for backwards compatibility
export const ApiErrorResponseSchema = z.preprocess(
    (item) => {
        if (typeof item === 'object' && item !== null) {
            return {
                detail:
                    // @ts-expect-error
                    item.description,
                ...item,
            };
        }
        return item;
    },
    z.object({
        detail: z.string(),
    })
);
